// extracted by mini-css-extract-plugin
export default {"main":"PageNotFound_main__-s3oB","message":"PageNotFound_message__yBgro","title":"PageNotFound_title__t8qTn","text":"PageNotFound_text__8eWkN"};